import { BASE_PATH as V, BaseAPI as A, operationServerMap as v } from "../base.js";
import { DUMMY_BASE_URL as S, assertParamExists as u, createRequestFunction as p, serializeDataIfNeeded as O, setSearchParams as C, toPathString as R } from "../common.js";
import m from "axios";
var y = function(r) {
  return {
    cashierStoredValueCardAvailability: async (l, s, o = {}) => {
      u("cashierStoredValueCardAvailability", "memberId", l), u("cashierStoredValueCardAvailability", "shopId", s);
      const a = new URL("/cashier/stored-value-card/availability", S);
      let e;
      r && (e = r.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, i = {}, d = {};
      l !== void 0 && (d.memberId = l), s !== void 0 && (d.shopId = s), C(a, d);
      let c = e && e.headers ? e.headers : {};
      return t.headers = {
        ...i,
        ...c,
        ...o.headers
      }, {
        url: R(a),
        options: t
      };
    },
    cashierStoredValueCardCompleteRecharge: async (l, s = {}) => {
      u("cashierStoredValueCardCompleteRecharge", "cashierRechargeCompleteRequestDTO", l);
      const o = new URL("/cashier/stored-value-card/recharge-orders/complete", S);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...s
      }, t = {}, i = {};
      t["Content-Type"] = "application/json", C(o, i);
      let d = a && a.headers ? a.headers : {};
      return e.headers = {
        ...t,
        ...d,
        ...s.headers
      }, e.data = O(l, e, r), {
        url: R(o),
        options: e
      };
    },
    cashierStoredValueCardDebit: async (l, s = {}) => {
      u("cashierStoredValueCardDebit", "storedValueDebitRequestDTO", l);
      const o = new URL("/cashier/stored-value-card/debit", S);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...s
      }, t = {}, i = {};
      t["Content-Type"] = "application/json", C(o, i);
      let d = a && a.headers ? a.headers : {};
      return e.headers = {
        ...t,
        ...d,
        ...s.headers
      }, e.data = O(l, e, r), {
        url: R(o),
        options: e
      };
    },
    cashierStoredValueCardListRechargeRules: async (l, s, o = {}) => {
      u("cashierStoredValueCardListRechargeRules", "memberId", l), u("cashierStoredValueCardListRechargeRules", "shopId", s);
      const a = new URL("/cashier/stored-value-card/recharge-rules", S);
      let e;
      r && (e = r.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, i = {}, d = {};
      l !== void 0 && (d.memberId = l), s !== void 0 && (d.shopId = s), C(a, d);
      let c = e && e.headers ? e.headers : {};
      return t.headers = {
        ...i,
        ...c,
        ...o.headers
      }, {
        url: R(a),
        options: t
      };
    },
    cashierStoredValueCardMatchRechargeRule: async (l, s = {}) => {
      u("cashierStoredValueCardMatchRechargeRule", "cashierRechargeRuleMatchRequestDTO", l);
      const o = new URL("/cashier/stored-value-card/recharge-rules/match", S);
      let a;
      r && (a = r.baseOptions);
      const e = {
        method: "POST",
        ...a,
        ...s
      }, t = {}, i = {};
      t["Content-Type"] = "application/json", C(o, i);
      let d = a && a.headers ? a.headers : {};
      return e.headers = {
        ...t,
        ...d,
        ...s.headers
      }, e.data = O(l, e, r), {
        url: R(o),
        options: e
      };
    }
  };
}, n = function(r) {
  const l = y(r);
  return {
    async cashierStoredValueCardAvailability(s, o, a) {
      var e, t;
      const i = await l.cashierStoredValueCardAvailability(s, o, a), d = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, c = (t = v["StoredValueCardCashierApi.cashierStoredValueCardAvailability"]) === null || t === void 0 || (t = t[d]) === null || t === void 0 ? void 0 : t.url;
      return (h, b) => p(i, m, V, r)(h, c || b);
    },
    async cashierStoredValueCardCompleteRecharge(s, o) {
      var a, e;
      const t = await l.cashierStoredValueCardCompleteRecharge(s, o), i = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, d = (e = v["StoredValueCardCashierApi.cashierStoredValueCardCompleteRecharge"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => p(t, m, V, r)(c, d || h);
    },
    async cashierStoredValueCardDebit(s, o) {
      var a, e;
      const t = await l.cashierStoredValueCardDebit(s, o), i = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, d = (e = v["StoredValueCardCashierApi.cashierStoredValueCardDebit"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => p(t, m, V, r)(c, d || h);
    },
    async cashierStoredValueCardListRechargeRules(s, o, a) {
      var e, t;
      const i = await l.cashierStoredValueCardListRechargeRules(s, o, a), d = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, c = (t = v["StoredValueCardCashierApi.cashierStoredValueCardListRechargeRules"]) === null || t === void 0 || (t = t[d]) === null || t === void 0 ? void 0 : t.url;
      return (h, b) => p(i, m, V, r)(h, c || b);
    },
    async cashierStoredValueCardMatchRechargeRule(s, o) {
      var a, e;
      const t = await l.cashierStoredValueCardMatchRechargeRule(s, o), i = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, d = (e = v["StoredValueCardCashierApi.cashierStoredValueCardMatchRechargeRule"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (c, h) => p(t, m, V, r)(c, d || h);
    }
  };
}, I = function(r, l, s) {
  const o = n(r);
  return {
    cashierStoredValueCardAvailability(a, e) {
      return o.cashierStoredValueCardAvailability(a.memberId, a.shopId, e).then((t) => t(s, l));
    },
    cashierStoredValueCardCompleteRecharge(a, e) {
      return o.cashierStoredValueCardCompleteRecharge(a.cashierRechargeCompleteRequestDTO, e).then((t) => t(s, l));
    },
    cashierStoredValueCardDebit(a, e) {
      return o.cashierStoredValueCardDebit(a.storedValueDebitRequestDTO, e).then((t) => t(s, l));
    },
    cashierStoredValueCardListRechargeRules(a, e) {
      return o.cashierStoredValueCardListRechargeRules(a.memberId, a.shopId, e).then((t) => t(s, l));
    },
    cashierStoredValueCardMatchRechargeRule(a, e) {
      return o.cashierStoredValueCardMatchRechargeRule(a.cashierRechargeRuleMatchRequestDTO, e).then((t) => t(s, l));
    }
  };
}, D = class extends A {
  cashierStoredValueCardAvailability(r, l) {
    return n(this.configuration).cashierStoredValueCardAvailability(r.memberId, r.shopId, l).then((s) => s(this.axios, this.basePath));
  }
  cashierStoredValueCardCompleteRecharge(r, l) {
    return n(this.configuration).cashierStoredValueCardCompleteRecharge(r.cashierRechargeCompleteRequestDTO, l).then((s) => s(this.axios, this.basePath));
  }
  cashierStoredValueCardDebit(r, l) {
    return n(this.configuration).cashierStoredValueCardDebit(r.storedValueDebitRequestDTO, l).then((s) => s(this.axios, this.basePath));
  }
  cashierStoredValueCardListRechargeRules(r, l) {
    return n(this.configuration).cashierStoredValueCardListRechargeRules(r.memberId, r.shopId, l).then((s) => s(this.axios, this.basePath));
  }
  cashierStoredValueCardMatchRechargeRule(r, l) {
    return n(this.configuration).cashierStoredValueCardMatchRechargeRule(r.cashierRechargeRuleMatchRequestDTO, l).then((s) => s(this.axios, this.basePath));
  }
};
export {
  D as StoredValueCardCashierApi,
  y as StoredValueCardCashierApiAxiosParamCreator,
  I as StoredValueCardCashierApiFactory,
  n as StoredValueCardCashierApiFp
};

//# sourceMappingURL=stored-value-card-cashier-api.js.map